module.exports = __webpack_public_path__ + "img/dianping.f9986e77.png";